export { default as ColorSpan } from "./ColorSpan/ColorSpan";
export { default as H1 } from "./H1/H1";
export { default as H2 } from "./H2/H2";
export { default as H3 } from "./H3/H3";
export { default as H4 } from "./H4/H4";
export { default as H5 } from "./H5/H5";
export { default as H6 } from "./H6/H6";
export { default as P } from "./P/P";
export { default as TitleWithHighlights } from "./TitleWithHighlights";
